import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../deployment'

@Injectable({
  providedIn: 'root'
})
export class EcachatRoomService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

    participantList($data: any) {
    return this.http.post(checkUrl()+"/ecademic/session/participantList",$data)
    .pipe((response)=>{
      return response;
    });
  }

    insertImage($data:any){
      return this.http.post(checkUrl()+"/chat/insert/image",$data)
      .pipe((response)=>{
        return response;
      });

    }

    insertDocument($data:any){
      return this.http.post(checkUrl()+"/chat/insert/document",$data)
      .pipe((response)=>{
        return response;
      });

    }

    public downloadDocument($data: any) {
      return this.http.post(checkUrl()+"/chat/download/document",$data,{ responseType:"blob"  })
      .pipe((response)=>{
        return response;
      })
    }
}


